import type { TemplateState } from '../../lib/adminTemplates';

const STYLES: Record<TemplateState, string> = {
  DRAFT: 'border-accent-border text-accent',
  PUBLISHED: 'border-border-strong text-text',
  RETIRED: 'border-border-strong text-text-faint line-through',
};

/** DRAFT accent (still editable) / PUBLISHED plain / RETIRED muted+struck — per the WP10 spec's
 * list page ("state chip: DRAFT accent / PUBLISHED / RETIRED muted"). */
export function TemplateStateChip({ state }: { state: TemplateState }) {
  return (
    <span className={`eyebrow inline-flex items-center rounded-full border px-2.5 py-1 ${STYLES[state]}`}>
      {state}
    </span>
  );
}
